// Textos de Admin › Eventos (catálogo de eventos y sus categorías). Se
// registran junto al resto de vocabularios en AppComponent; setTranslation los
// fusiona (también SIDEBAR y PAGE_HEADER).
export const locale = {
  lang: 'en',
  data: {
    SIDEBAR: {
      EVENTS_SECTION: 'Events',
      EVENTS: 'Events',
      EVENT_CATEGORIES: 'Event categories',
    },
    PAGE_HEADER: {
      EVENTS: 'Concerts, matches, festivals… that users create trips to. Add, edit, cancel or reactivate each event.',
      EVENT_CATEGORIES: 'The categories chosen when adding an event, and their name in each language.',
      EVENTS_TICKETMASTER: 'Ticketmaster events in Spain over the coming days. Pick the ones you want and add them to the catalogue in one go.',
    },
    EVENTS: {
      LOADING: 'Loading…',
      RETRY: 'Retry',
      SAVE: 'Save',
      SAVE_CHANGES: 'Save changes',
      SAVING: 'Saving…',
      DELETING: 'Deleting…',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      COL_STATUS: 'Status',
      COL_ACTIONS: 'Actions',
      FIELD_REQUIRED: 'This field is required.',
      GENERIC_ERROR: 'Something went wrong. Please try again in a few minutes.',
      STATUS: {
        active: 'Active',
        cancelled: 'Cancelled',
      },
      LEGACY: {
        concert: 'Concert',
        sport: 'Sport',
        festival: 'Festival',
        fair: 'Fair',
        theatre: 'Theatre',
        other: 'Other',
      },
      SOURCE: {
        backoffice: 'Dashboard',
        ticketmaster: 'Ticketmaster',
      },
      LIST: {
        ADD: 'New event',
        IMPORT_TICKETMASTER: 'Import from Ticketmaster',
        IMPORT_FOOTBALL_DATA: 'Import Primera División',
        PANEL_TITLE: 'Upcoming events',
        PANEL_TITLE_ALL: 'All events',
        PANEL_SUB: 'Sorted by date. Times are the venue’s local time. Without “Include past”, only events that have not ended are shown.',
        SEARCH: 'Search by name or performer…',
        STATUS_ALL: 'All statuses',
        FILTER_CATEGORIES: 'Categories',
        FILTER_CITY: 'City',
        FILTER_FROM: 'From',
        FILTER_TO: 'To',
        FILTER_PAST: 'Past events',
        FILTER_INCLUDE_PAST: 'Include past',
        DATES_INVALID: 'The “To” date can’t be earlier than “From”.',
        CHIP_BETWEEN: 'From {{from}} to {{to}}',
        CHIP_FROM: 'From {{from}}',
        CHIP_TO: 'Until {{to}}',
        REMOVE_FILTER: 'Remove the filter {{label}}',
        COL_DATE: 'Date',
        COL_EVENT: 'Event',
        COL_CATEGORY: 'Category',
        COL_PLACE: 'Place',
        COL_TRIPS: 'Trips',
        EMPTY: 'There are no upcoming events.',
        EMPTY_FILTERED: 'No event matches the filters.',
        LOAD_ERROR: 'The events could not be loaded.',
        SHOWING: 'Showing {{shown}} of {{total}} events',
        PER_PAGE: '{{count}} per page',
        PER_PAGE_ARIA: 'Events per page',
      },
      TICKETMASTER: {
        TITLE: 'Import from Ticketmaster',
        PANEL_TITLE: 'Events on Ticketmaster',
        PANEL_SUB: "In Spain, from today to {{until}} ({{days}} days). Times are the venue's. You can pick events from several pages.",
        PANEL_SUB_GENERIC: "In Spain, from today over the coming days. Times are the venue's.",
        SEARCH: 'Search by name, artist or venue…',
        LOAD_ERROR: "Couldn't load the Ticketmaster events.",
        EMPTY: 'Ticketmaster has no events for these dates.',
        EMPTY_FILTERED: 'No Ticketmaster events match the search.',
        SHOWING: 'Showing {{shown}} of {{total}} shows ({{dates}} dates)',
        SELECT_PAGE: 'Select all on this page',
        SELECT_ROW: 'Select “{{name}}”',
        SELECT_GROUP: 'Select every date of “{{name}}”',
        DATES: '{{count}} dates',
        DATES_RANGE: 'From {{from}} to {{to}}',
        SHOW_DATES: 'Show dates',
        HIDE_DATES: 'Hide dates',
        GROUP_IN_CATALOG: '{{count}} in the catalogue',
        TIME_TBD: 'Time TBC',
        TIME_TBD_HINT: "Ticketmaster hasn't announced the time yet. It will be saved at 00:00: fix it on the event page once it's known.",
        NO_VENUE: 'No venue',
        IN_CATALOG: 'In the catalogue',
        IN_CATALOG_HINT: "It's already in the catalogue.",
        CANCELLED_HINT: "It's cancelled on Ticketmaster.",
        MISSING: "Ticketmaster doesn't provide all the details (missing: {{fields}}). If you need it, create it by hand from “New event”.",
        INCOMPLETE: 'Incomplete details',
        INVALID: 'Not added',
        INVALID_HINT: "The catalogue didn't accept it. Check: {{fields}}.",
        EXTERNAL_ID: 'Ticketmaster ID',
        OPEN_TM: 'View on Ticketmaster',
        SELECTION: 'Selected events',
        SELECTED: 'Selected events: {{count}}',
        NEEDS_CATEGORY: 'Choose the category of the ones marked in red ({{count}}).',
        CLEAR_SELECTION: 'Clear selection',
        IMPORT: 'Add to catalogue ({{count}})',
        IMPORTING: 'Adding…',
        IMPORT_ERROR: "Couldn't add the events",
        RESULT_CREATED: 'Events added to the catalogue: {{count}}',
        RESULT_NONE_NEW: 'The selected events were already in the catalogue',
        RESULT_PARTIAL: '{{created}} of {{sent}} events added to the catalogue',
        RESULT_FAILED: 'No events were added to the catalogue',
        RESULT_EXISTING: 'Already there: {{count}}.',
        RESULT_INVALID: 'With errors: {{count}} (marked in the table).',
        GO_TO_EVENTS: 'View events',
        KEEP_IMPORTING: 'Keep importing',
        TM_STATUS: {
          offsale: 'Off sale',
          cancelled: 'Cancelled on Ticketmaster',
          canceled: 'Cancelled on Ticketmaster',
          postponed: 'Postponed',
          rescheduled: 'Rescheduled',
        },
      },
      FOOTBALL_DATA: {
        CONFIRM_TITLE: 'Import first-division matches?',
        CONFIRM_TEXT: 'Brings from football-data the Primera División matches of the coming days that already have an official kick-off time. Matches already in the catalogue are updated if the time has changed.',
        CONFIRM: 'Import matches',
        IMPORTING: 'Importing…',
        DONE: 'Imported',
        RESULT_TITLE: 'New matches: {{created}} · new time: {{updated}}',
        RESULT_NONE: 'No new matches or time changes',
        UNCHANGED: 'Already there, unchanged: {{count}}.',
        UNCONFIRMED: 'No official time yet: {{count}}. They will come in when you import again once they have one.',
        CONFLICTS: 'Their time changed but they have pending trips, so they were not moved ({{count}}). Check them in their page:',
        CONFLICT_ITEM: '{{name}}: {{now}} → {{next}}',
        SKIPPED: 'Unknown stadium, not imported ({{count}}): {{names}}.',
        WINDOW: 'Matches until {{until}} ({{days}} days). Times in Madrid time.',
      },
      DETAIL: {
        TITLE: 'Event details',
        NEW_TITLE: 'New event',
        BACK: 'Back to the list',
        CREATE: 'Create event',
        TRIPS: 'Linked trips',
        PENDING_ROUTES: 'Legs yet to depart',
        PENDING_USERS: 'Users with trips',
        TIME_ZONE: 'Time zone',
        SOURCE: 'Source',
        SEE_LINKED: 'See linked trips',
        CANCELLED_TITLE: 'Event cancelled',
        CANCELLED_TEXT: 'It no longer shows in the app and accepts no new trips. Its pending trips are cancelled in the background, with no penalty, and each user gets a notification.',
        LOAD_ERROR: 'The event could not be loaded.',
        SAVE_ERROR: 'The event could not be saved.',
        CREATED_TITLE: 'Event created',
        SAVED_TITLE: 'Changes saved',
      },
      FORM: {
        SECTION_EVENT: 'Event',
        SECTION_PLACE: 'Place',
        SECTION_WHEN: 'Date and time',
        NAME: 'Name',
        PERFORMER: 'Performer or teams',
        PERFORMER_HINT: 'Optional. For example, the band or the teams playing.',
        CATEGORY: 'Category',
        CATEGORY_PLACEHOLDER: 'Choose a category',
        CATEGORY_INACTIVE: '{{name}} (deactivated)',
        PLACE_SEARCH: 'Search for the venue or address',
        PLACE_SEARCH_PLACEHOLDER: 'Stadium, hall, exhibition centre…',
        PLACE_SEARCH_HINT: 'Choosing a place fills in the venue, address, city and location. You can edit the texts afterwards.',
        PLACE_LOCKED: 'The location can’t be changed: the event has trips that haven’t departed yet.',
        VENUE: 'Venue',
        ADDRESS: 'Address',
        CITY: 'City',
        LOCATION: 'Location',
        SEE_MAP: 'See on the map',
        NO_LOCATION: 'No location: choose the place in the search box.',
        LOCATION_REQUIRED: 'Choose the place in the search box to set the location.',
        START_DATE: 'Start day',
        START_TIME: 'Start time',
        END_DATE: 'End day',
        END_TIME: 'End time',
        START_REQUIRED: 'Enter the start day and time.',
        END_TIME_REQUIRED: 'Enter the end time too.',
        END_BEFORE_START: 'The end can’t be earlier than the start.',
        TIME_ZONE: 'Venue time zone',
        TIME_ZONE_HINT: 'Times are saved in this zone. It is set automatically when you choose the place.',
        TZ_MADRID: 'Mainland Spain, Balearic Islands, Ceuta and Melilla (Europe/Madrid)',
        TZ_CANARY: 'Canary Islands (Atlantic/Canary)',
        LOCKED_TITLE: 'It has trips that haven’t departed yet ({{routes}})',
        LOCKED_TEXT: 'The date, time, time zone and location can’t be changed. If it has to move, cancel it (users are notified) and create a new one.',
        CHECK_FIELDS: 'Check the highlighted fields.',
        NO_CHANGES: 'You haven’t changed anything.',
      },
      LINKED: {
        TITLE: 'Linked trips',
        SUB: 'Users’ legs to or from the event that haven’t departed yet, one per row.',
        EMPTY: 'There are no trips waiting to depart.',
        LOAD_ERROR: 'The linked trips could not be loaded.',
        COL_USER: 'User',
        COL_ROLE: 'Role',
        COL_LEG: 'Leg',
        COL_DEPARTURE: 'Departure',
        COL_MATCH: 'Match',
        MATCHED: 'Matched',
        NOT_MATCHED: 'No match',
        ROLE: {
          driver: 'Driver',
          rider: 'Passenger',
        },
        LEG: {
          outbound: 'Outbound',
          return: 'Return',
        },
        SUMMARY_OUTBOUND: 'Outbound: {{count}}',
        SUMMARY_RETURN: 'Return: {{count}}',
        SUMMARY_DRIVERS: 'Drivers: {{count}}',
        SUMMARY_RIDERS: 'Passengers: {{count}}',
        SUMMARY_MATCHED: 'Matched: {{count}}',
      },
      ACTIONS: {
        CANCEL: 'Cancel event',
        KEEP: 'Don’t cancel',
        CANCEL_TITLE: 'Cancel “{{name}}”',
        CANCEL_TEXT_NO_TRIPS: 'It has no pending trips. It will no longer show in the app or accept new trips.',
        CANCEL_SUMMARY_ROUTES: 'Legs that will be cancelled: <b>{{routes}}</b>',
        CANCEL_SUMMARY_USERS: 'Users who will be notified: <b>{{users}}</b>',
        CANCEL_SUMMARY_SPLIT: '<span class="bo-swal-muted">Outbound {{outbound}} · return {{back}} · driver {{drivers}} · passenger {{riders}}</span>',
        CANCEL_SUMMARY_NOTE: 'They are cancelled in the background and with no penalty. The event no longer shows in the app.',
        CANCELLING: 'Cancelling…',
        CANCELLED: 'Cancelled',
        REACTIVATE: 'Reactivate event',
        REACTIVATE_TITLE: 'Reactivate “{{name}}”',
        REACTIVATE_TEXT: 'It will show in the app again and accept new trips. Trips that were cancelled are not restored.',
        REACTIVATED: 'Reactivated',
        DELETE: 'Delete event',
        DELETE_TITLE: 'Delete “{{name}}”',
        DELETE_TEXT: 'Only for events without trips, such as one created by mistake. This can’t be undone.',
        DELETED: 'Deleted',
        DELETE_BLOCKED_TITLE: 'The event can’t be deleted',
        DELETE_BLOCKED_TEXT: 'It has trips. You can cancel it instead.',
        ERROR_TITLE: 'The action could not be completed',
      },
      CATEGORIES: {
        ADD: 'New category',
        TABS_ARIA: 'Category status',
        TAB_all: 'All',
        TAB_active: 'Active',
        TAB_inactive: 'Deactivated',
        PANEL_TITLE_all: 'All categories',
        PANEL_TITLE_active: 'Active categories',
        PANEL_TITLE_inactive: 'Deactivated categories',
        PANEL_SUB: 'In the order they appear in the app. Deactivated ones can’t be chosen for a new event; events that already have one keep it.',
        COL_NAME: 'Name',
        COL_CODE: 'Code',
        COL_LEGACY: 'General category',
        COL_ORDER: 'Order',
        COL_EVENTS: 'Events',
        ACTIVE: 'Active',
        INACTIVE: 'Deactivated',
        BASE: 'Basic',
        BASE_HINT: 'One of the 6 original categories: it can’t be deleted.',
        EMPTY: 'There are no categories in this view.',
        LOAD_ERROR: 'The categories could not be loaded.',
        EDIT: 'Edit category',
        NEW_TITLE: 'New category',
        NEW_SUB: 'It can be chosen when adding an event.',
        EDIT_TITLE: 'Edit category',
        SECTION_NAME: 'Name in each language',
        SECTION_CLASSIFICATION: 'Classification',
        NAME_ES: 'Spanish',
        NAME_EN: 'English',
        NAME_CA: 'Catalan',
        CODE_HINT: 'Stable identifier: lowercase letters, numbers and “_”. It is suggested from the Spanish name and can’t be changed later.',
        CODE_LOCKED: 'The code can’t be changed.',
        CODE_INVALID: 'Only lowercase letters without accents, numbers and “_”, up to 32 characters.',
        LEGACY_PLACEHOLDER: 'Choose the general category',
        LEGACY_HINT: 'General category it belongs to: it is what older versions of the app show. It can’t be changed later.',
        LEGACY_LOCKED: 'The general category can’t be changed.',
        ORDER_HINT: 'Position in the lists (lowest first).',
        ORDER_INVALID: 'A whole number between 0 and 100,000.',
        ACTIVE_CHECK: 'Active',
        ACTIVE_HINT: 'When deactivated, it can’t be chosen for a new event.',
        CREATE: 'Create category',
        CREATED_TITLE: 'Category created',
        SAVED_TITLE: 'Changes saved',
        SAVE_ERROR: 'The category could not be saved.',
        ACTIVATE: 'Activate',
        ACTIVATE_TITLE: 'Activate “{{name}}”',
        ACTIVATE_TEXT: 'It can be chosen again when adding an event.',
        ACTIVATED: 'Activated',
        DEACTIVATE: 'Deactivate',
        DEACTIVATE_TITLE: 'Deactivate “{{name}}”',
        DEACTIVATE_TEXT: 'It can’t be chosen for new events. Events that already have it keep it.',
        DEACTIVATED: 'Deactivated',
        DELETE: 'Delete category',
        DELETE_TITLE: 'Delete “{{name}}”',
        DELETE_TEXT: 'Only categories without events can be deleted. This can’t be undone.',
        DELETED: 'Deleted',
        DELETE_BLOCKED_TITLE: 'The category can’t be deleted',
        DELETE_BLOCKED_BASE: 'It is one of the 6 original categories: deactivate it instead.',
        DELETE_BLOCKED_IN_USE: 'It has events: deactivate it instead.',
        ACTION_ERROR: 'The action could not be completed',
      },
    },
  },
};
